import * as ng from 'angular';

class ArchidriveNewFolderController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
    ];

    private close: any;
    private dismiss: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
    ) {
        $scope.path = $scope.$parent.$resolve.path;
        $scope.foldername = '';
        $scope.foldernamePattern = new RegExp('^[^\\\\/:*?"<>|]+$');
        $scope.create = (errors) => {
            if ($.isEmptyObject(errors)) {
                this.close({ $value: $scope.foldername });
            } else {
                $rootScope.setErrorFieldsTouched(errors);
                $('[name=\'form\']').find('.ng-invalid:visible:first').focus();
            }
        };
        $scope.cancel = () => {
            this.dismiss();
        };
    }
}

export const ArchidriveNewFolderComponent: ng.IComponentOptions = {
    template: require('./archidrive-new-folder.html'),
    controller: ArchidriveNewFolderController,
    bindings: {
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/archidrive/archidrive-new-folder/archidrive-new-folder.ts